/**
 * VideosController — /api/v1/videos
 * Mirrors: src/Aidepo.Api/Controllers/VideosController.cs
 *
 * Phase 4.4 — обучающие ролики (case-27). Ролики — reference data; бэкенд
 * помечает каждый флагом hasMatchingEquipment и отдаёт id первой подходящей
 * единицы оборудования пользователя (matchingEquipmentId).
 */
import { apiGet } from '../client.js';
import type { Uuid } from '../types.js';

/** Один ролик из GET /api/v1/videos. */
export interface VideoRow {
  readonly id: Uuid;
  readonly title: string;
  readonly url: string;
  readonly lengthSec: number;
  readonly linkedCatalogType: string | null;
  /** У пользователя есть оборудование того же типа. */
  readonly hasMatchingEquipment: boolean;
  /** Id первой подходящей единицы оборудования, либо null. */
  readonly matchingEquipmentId: Uuid | null;
}

export interface ListVideosResponse {
  readonly videos: readonly VideoRow[];
}

/** GET /api/v1/videos — каталог обучающих роликов. */
export function listVideos(): Promise<ListVideosResponse> {
  return apiGet<ListVideosResponse>('/api/v1/videos');
}

/** «2:30» из длительности в секундах. */
export function formatLength(lengthSec: number): string {
  const m = Math.floor(lengthSec / 60);
  const s = lengthSec % 60;
  return `${m}:${s.toString().padStart(2, '0')}`;
}
